import Image from 'next/image';

import { Section, SectionHeader } from '@/components/atomic/nuclei';
import { staticMediaStoreBaseURL } from '@/config/common';
import { useIsMobile } from '@/helpers/screenResolutionHelper';

const HumanAICollaboration = () => {
  const [isMobile] = useIsMobile();
  return (
    <>
      <Section>
        <SectionHeader
          gradientText='Collaboration'
          text='Human x AI'
        />
        <div className='w-full flex flex-col lg:flex-row gap-8 lg:items-stretch'>
          <div className='flex-1 flex flex-col justify-between'>
            <ul className='list-disc text-sm md:text-xl text-gray-700 pl-5 space-y-2 mb-6'>
              <li>We don’t replace event planners; we augment them.</li>
              <li>
                Our AI handles intensive analysis, multi-variable sourcing, and
                workflow automation.
              </li>
              <li>
                Our planners bring taste, judgment, empathy, and white-glove
                delivery.
              </li>
            </ul>

            <div className='border border-brand rounded-xl p-6 bg-white mt-auto'>
              <div className='text-base md:text-xl font-semibold text-brand mb-4'>
                The Result:
              </div>
              <ul className='space-y-3'>
                {[
                  'Compressed planning cycles (days → hours)',
                  'Transparent option trade-offs and data-backed pricing',
                  'Fewer errors and escalations across suppliers'
                ].map((text, i) => (
                  <li
                    key={i}
                    className='flex items-start gap-3'
                  >
                    <Image
                      alt='Check with circle'
                      height={isMobile ? 20 : 28}
                      width={isMobile ? 20 : 28}
                      style={{
                        width: isMobile ? '20px' : '28px',
                        height: isMobile ? '20px' : '28px'
                      }}
                      priority={true}
                      src={`${staticMediaStoreBaseURL}/icons/check-with-circle-brand.svg`}
                    />
                    <span className='text-sm md:text-xl text-gray-700'>
                      {text}
                    </span>
                  </li>
                ))}
              </ul>
              <div className='text-brand font-semibold mt-4 text-sm md:text-xl'>
                You get AI scale with human sensibility.
              </div>
            </div>
          </div>

          <div className='flex-1 flex justify-center items-stretch'>
            <div className='relative w-full rounded-2xl overflow-hidden human-ai-collab-image'>
              <Image
                alt='Human AI Collaboration'
                className='rounded-2xl'
                fill
                style={{ objectFit: 'cover' }}
                priority
                src={`${staticMediaStoreBaseURL}/about-hafla/human-ai-collab/human-ai-collab.png`}
              />
            </div>
          </div>
        </div>
      </Section>
      <div className='border-t border-pink-100 container mx-auto' />
    </>
  );
};

export default HumanAICollaboration;
